import axios from '../api';

export default {
  namespaced: true,

  state: {

    referentiels:{
      compperso:[],
      compsocio:[],
      comppro:[],
    },

    searching:{
      compperso:[
        {
          datas: {domaines: [], competences:[], niveaux:[]},
          values: {categories: {}, domaines: {}, competences:{}, niveaux:{}}
        },
      ],
      compsocio:[
        {
          datas: {competences:[], niveaux:[]},
          values: {categories: {}, competences:[], niveaux:{}}
        },
      ],
      comppro:[
        {
          datas: {domaines: [], competences:[], niveaux:[]},
          values: {categories: {}, domaines: {}, competences:[], niveaux:[]}
        },
      ],
    },
  },

  getters: {


    referentiels(state){
      return state.referentiels;
    },

    searching(state){
      return state.searching;
    },
  },

  mutations: {


    SET_REFERENTIELS(state, list){
      state.referentiels = list;
    },

    SET_SEARCHING(state, list){
      state.searching = list;
    },
  },

  actions: {
    async loadReferentiels(context){
      await axios.get('api/recherche/loadReferentiels').then(response => {
        context.commit('SET_REFERENTIELS', response.data);
      }).catch(() => {

      });
    },
  }
};
